import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredDateWithDayColumn,
    FilteredNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Location', 'operatorCode').withWidth(102.1),
        new FilteredDateWithDayColumn('Date', 'date').withWidth(122.1),
      ],
    },
    {
      Header: 'Generated from PREDES',
      columns: [
        new FilteredNumberColumn('In', 'generatedFromPredes.in').withWidth(90),
        new FilteredNumberColumn('Out', 'generatedFromPredes.out').withWidth(90),
        new FilteredNumberColumn('Total', 'generatedFromPredes.total').withWidth(90),
      ],
    },
    {
      Header: 'Manual Pre-Advise',
      columns: [
        new FilteredNumberColumn('In', 'manualPreadvice.in').withWidth(90),
        new FilteredNumberColumn('Out', 'manualPreadvice.out').withWidth(90),
        new FilteredNumberColumn('Total', 'manualPreadvice.total').withWidth(90),
      ],
    },
    {
      Header: 'Center Initiated Repat',
      columns: [
        new FilteredNumberColumn('In', 'centralRepatriation.in').withWidth(90),
        new FilteredNumberColumn('Out', 'centralRepatriation.out').withWidth(90),
        new FilteredNumberColumn('Total', 'centralRepatriation.total').withWidth(90),
      ],
    },
    {
      Header: 'Internal Repat',
      columns: [
        new FilteredNumberColumn('In', 'internalRepatriation.in').withWidth(90),
        new FilteredNumberColumn('Out', 'internalRepatriation.out').withWidth(90),
        new FilteredNumberColumn('Total', 'internalRepatriation.total').withWidth(90),
      ],
    },
    {
      Header: 'Total',
      columns: [
        new FilteredNumberColumn('In', 'total.in').withWidth(90),
        new FilteredNumberColumn('Out', 'total.out').withWidth(90),
        new FilteredNumberColumn('Flux', 'total.flux').withWidth(90),
      ],
    },
    {
      Header: '',
      columns: [
        new FilteredNumberColumn('Balance Modification', 'balanceModificationCount').withWidth(112.2),
        new FilteredNumberColumn('Balance on Hand', 'balanceOnHand').withWidth(112.2),
      ],
    },
  ];
};
